import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Typography from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useLaunchDarklyFlags from "@MasterBluePrint/Common/Hooks/useLaunchDarklyFlags";
import themeColors, { themeFontSizes } from "@MasterBluePrint/Styles/variables";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: ProductListProductCountStyles;
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        homeLink: getPageLinkByPageType(state, "HomePage")
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasHistory;

export interface ProductListProductCountStyles {
    wrapper?: InjectableCss;
    continueShoppingLink?: InjectableCss;
    continueButton?: ButtonPresentationProps;
}

export const productCountStyles: ProductListProductCountStyles = {
    wrapper: {
        css: css`
            margin-top: .625rem;
            color: ${themeColors.colorCharcoalGrey};
            font-size: ${themeFontSizes.size14};
            letter-spacing: 0;
            font-family: Lato;
            font-size: 15px;
            font-weight: bold;
            letter-spacing: 0.17px;
            line-height: 18px;
            padding-bottom: 10px;
            margin-bottom: 15px;
            border-bottom: 1px solid #C2D1D9;
        `,
    },
    continueShoppingLink: {
        css: css`
            padding-bottom: 190px;
            position: relative;
            width: 100%;
            @media screen and (max-width: 990px) {
                padding-bottom: 70px;
            }
            @media screen and (max-width: 767px) {
                padding-bottom: 10px;
            }
            &:after {
                content: "";
                border-bottom: 1px solid #C2D1D9;
                width: 80%;
                position: absolute;
                left: 40%;
                margin-left: -30%;
                top: 92px;

                @media screen and (max-width: 990px) {
                    top: 48px;
                }

                @media screen and (max-width: 767px) {
                    width: 90%;
                    left: 45%;
                    margin-left: -39%;
                    display: none;
                }
            }

            @media print {
                padding-bottom: 0;

                &:after {
                    content: none;
                }
            }

            .btn-containter {
                background: #f7f9fa;
                position: absolute;
                top: 74px;
                left: 50%;
                width: 444px;
                margin-left: -222px;
                text-align: center;
                z-index: 1;
                
                @media screen and (min-width: 768px) and (max-width: 990px) {
                    width: 360px;
                    margin-left: -180px;
                    top: 1.875rem;
                }
    
                @media screen and (max-width: 767px) {
                    margin-left: 0;
                    width: 100%;
                    left: 0;
                    top: 15px;

                    button {
                        width: 100%;
                    }
                }
            }
        `,
    },
    continueButton: {
        buttonType: "outline",
        variant: "secondary",
        css: css`
            border-width: 1px;
            font-family: Roboto;
            font-size: .875rem;
            letter-spacing: 0;
            line-height: 1.3125rem;
            text-transform: uppercase;
            width: 344px;
            background: #fff;

            span {
                font-size: .875rem;
                font-weight: normal;
            }

            @media screen and (min-width: 768px) and (max-width: 990px) {
                width: 300px;
            }

            @media (max-width: 768px) {
                width: 240px;
            }
        `,
    }
};

const styles = productCountStyles;

const ContinueShoppingLink: FC<Props> = ({ homeLink, history }) => {
    const featureFlags =  ["TEUS-7937"];
    const flagValues = useLaunchDarklyFlags({ featureFlags });
    const isContinueButtonOnCartPageHidden = flagValues["TEUS-7937"];

    const continueShoppingClickHandler = () => {
        if (homeLink) {
            history.push(homeLink.url);
        }
    };

    return (
        <>
            {
                !isContinueButtonOnCartPageHidden
                &&
                <Typography as="div" {...styles.continueShoppingLink}>
                    <Typography as="div" className="btn-containter">
                        <Button onClick={continueShoppingClickHandler} {...styles.continueButton}>{translate("Continue Shopping")}</Button>
                    </Typography>
                </Typography>
            }
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(ContinueShoppingLink)),
    definition: {
        group: "Basic",
        displayName: "Continue Shopping Link"
    },
};

export default widgetModule;
